<template>
  <div>
    <BaseHeader>
      <template v-slot:title>Settings</template>
    </BaseHeader>

    <b-container>
      <b-row v-show="bothAnswered">
        <b-col v-show="passwordAvailable" :md="colWidth">
          <!-- Entra-native password change - see FormChangePasswordSso for
               why there is no current-password field. -->
          <FormChangePasswordSso @availability="onPasswordAvailability" />
        </b-col>
        <b-col
          v-show="mfaAvailable"
          :md="colWidth"
          :class="{ 'mt-5 mt-md-0': bothVisible }"
        >
          <!-- The one remaining 2FA panel, for MFA methods (e.g. phone). -->
          <Form2FASettingsSso @availability="onMfaAvailability" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { defineComponent, ref, computed } from '@vue/composition-api'

import { BaseHeader } from '@/components/base'
import FormChangePasswordSso from '@components/FormChangePasswordSso.vue'
import Form2FASettingsSso from '@components/Form2FASettingsSso.vue'

export default defineComponent({
  name: 'UserSettings',
  title: 'Settings',
  components: {
    BaseHeader,
    FormChangePasswordSso,
    Form2FASettingsSso
  },
  setup() {
    // null = that panel hasn't reported yet. Holding the row at v-show=false
    // until both have answered avoids a flash of a lopsided half-width
    // column before the slower of the two availability GETs resolves.
    const passwordAvailable = ref(null)
    const mfaAvailable = ref(null)

    const bothAnswered = computed(
      () => passwordAvailable.value !== null && mfaAvailable.value !== null
    )
    // Both panels actually showing, vs. only one of them - drives both the
    // column width and the stacked-on-mobile spacing, so it's one flag
    // instead of two copies of the same check.
    const bothVisible = computed(
      () => passwordAvailable.value === true && mfaAvailable.value === true
    )
    // Full width when only one panel applies, so a disabled feature flag
    // never leaves an empty half-width column next to the other panel.
    const colWidth = computed(() => (bothVisible.value ? '6' : '12'))

    return {
      passwordAvailable,
      mfaAvailable,
      bothAnswered,
      bothVisible,
      colWidth,
      onPasswordAvailability: (v) => { passwordAvailable.value = v },
      onMfaAvailability: (v) => { mfaAvailable.value = v }
    }
  }
})
</script>
